<template>
  <pt-qr-code-form ref="form" class="pt-qr-code-form__withData" :groupList="groupList"></pt-qr-code-form>
</template>

<script>
import PtQrCodeForm from './from'
export default {
  name: 'pt-qr-code-form__withData',
  components: {
    'pt-qr-code-form': PtQrCodeForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  data () {
    return {
      groupList: []
    }
  },
  methods: {
    // 判断是否已选择用户
    isSelectedUser () {
      let importCustomer = false
      let formValue = this.form.formValue
      if (formValue.mallUserCriteria && formValue.mallUserCriteria && formValue.mallUserCriteria.whiteList &&
      formValue.mallUserCriteria.whiteList.length) {
        formValue.mallUserCriteria.whiteList.forEach(item => {
          if (item.userListId) {
            importCustomer = true
          }
        })
      }
      return (formValue.mallUserIds && formValue.mallUserIds.length) || importCustomer
    },
    submit () {
      this.form.validate().then(formValue => {
        if (!formValue.commodityId) {
          this.$message.error('请选择商品')
        } else {
          if (!this.isSelectedUser()) {
            this.$message.error('请至少选择一个用户')
          } else {
            this.$emit('submitLoading', true)
            this.$store.dispatch('createQrCode', formValue).then(data => {
              this.$emit('submitLoading', false)
              // doing something ...
              this.$message.success('创建商品二维码成功')
              history.go(-1)
            }).catch(errorMessage => {
              this.$emit('submitLoading', false)
              console.error(errorMessage)
              this.$message.error(errorMessage)
            })
          }
        }
      })
    }
  },
  getGroupList () {
    let data = {
      example: {},
      pageable: {
        page: 0,
        size: 99999
      }
    }
    this.$store.dispatch('getGoodsGroup', data).then(res => {
      this.groupList = res.data
      res.data.forEach((item, index) => {
        if (item.id === 'gene-unlock') {
          res.data.splice(index, 1)
        }
      })
      this.groupTabs = res.data
      this.selectTab = res.data[0].id
    }).catch(err => {
      this.$message(err || '获取商品分组列表失败')
    })
  }
}
</script>
